// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__2an36","horizontal":"Footer_horizontal__Ziwv9","copy":"Footer_copy__UHUQb"};